import { httpClient } from './httpClient';
import type { TelegramAuthRequest, TelegramAuthResponse } from './types';

export const authApi = {
  exchangeTelegramAuth: (initData: string): Promise<TelegramAuthResponse> => {
    return httpClient.post<TelegramAuthResponse>('/auth/telegram/exchange', {
      initData,
    } satisfies TelegramAuthRequest);
  },
};
